import { atom } from "jotai";

import type { PaletteMode } from "../types";
import { highlightedIndexAtom } from "./highlight";
import { commandPaletteAtom } from "./state";

export const queryAtom = atom(
  (get) => get(commandPaletteAtom).query,
  (_get, set, value: string) => {
    set(commandPaletteAtom, (draft) => {
      draft.query = value;
    });
    set(highlightedIndexAtom, 0);
  },
);

export const modeAtom = atom<PaletteMode>((get) =>
  get(queryAtom).startsWith("/") ? "command" : "search",
);

export const commandQueryAtom = atom((get) => {
  const query = get(queryAtom);

  return query.startsWith("/") ? query.slice(1) : query;
});
